import { useHistory } from 'react-router-dom';
import AssessmentFlowComponent from 'components/assessment-flow';
import { ADHD_ASSESSMENT_QUESTIONS } from 'components/shared/analytics/segment-events';
import { ADHD } from 'components/shared/types';

export const AdhdAssessment = () => {
  const history = useHistory();

  const handleNextPage = () => {
    history.push('/adhd-assessment-email');
  };
  return (
    <AssessmentFlowComponent
      serviceLine={ADHD}
      handleNextPage={handleNextPage}
      segmentEventName={ADHD_ASSESSMENT_QUESTIONS}
    />
  );
};

export default AdhdAssessment;
